export const daysAgo = (datetime) => {
  const createdAt = new Date(datetime);
  const currentTime = new Date();

  const timeDifference = currentTime.getTime() - createdAt.getTime();
  const positiveTimeDifference = Math.abs(timeDifference);
  const days = Math.floor(positiveTimeDifference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((positiveTimeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((positiveTimeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((positiveTimeDifference % (1000 * 60)) / 1000);
  let elapsedTime = "";
  if (days > 0) {
    elapsedTime = `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (hours > 0) {
    elapsedTime = `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else if (minutes > 0) {
    elapsedTime = `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
  } else {
    elapsedTime = `${seconds} second${seconds > 1 ? "s" : ""} ago`;
  }

  return elapsedTime;
};

// export const formatCurrency = (amount) => {
//     try {
//         // Handle null or undefined cases
//         if (amount === null || amount === undefined) {
//             return '$0.00';
//         }

//         // Convert to number if string, or use as-is if already a number
//         const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

//         // Check if conversion resulted in NaN or invalid number
//         if (isNaN(numericAmount) || !isFinite(numericAmount)) {
//             return '$0.00';
//         }

//         // Format the valid number as currency
//         return numericAmount.toLocaleString('en-US', {
//             style: 'currency',
//             currency: 'USD',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         });
//     } catch (error) {
//         // Fallback in case of unexpected errors
//         console.error('Error formatting currency:', error);
//         return '$0.00';
//     }
// };

export const formatCurrency = (amount) => {
  try {
    // Handle null or undefined cases
    if (amount === null || amount === undefined) {
      return "CI$ 0.00";
    }

    // Convert to number if string, or use as-is if already a number
    const numericAmount = typeof amount === "string" ? parseFloat(amount) : amount;

    // Check if conversion resulted in NaN or invalid number
    if (isNaN(numericAmount) || !isFinite(numericAmount)) {
      return "CI$ 0.00";
    }

    // Format the valid number as currency
    return (
      "CI$ " +
      numericAmount.toLocaleString("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    );
  } catch (error) {
    // Fallback in case of unexpected errors
    console.error("Error formatting currency:", error);
    return "CI$ 0.00";
  }
};

export function safeBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1" || normalized === "yes";
  }
  return false;
}

export const replacePlaceholders = (template, replacements) => {
  if (!template) return "";

  return template.replace(/{{(.*?)}}/g, (_, key) => {
    const trimmedKey = key.trim();

    if (Object.prototype.hasOwnProperty.call(replacements, trimmedKey)) {
      const value = replacements[trimmedKey];
      return value == null ? "" : String(value);
    }

    return "";
  });
};
